export default __webpack_public_path__ + "static/media/2105.0f262839.png";